import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // core styles
import "swiper/css/free-mode"; // if you want freeMode
import { FreeMode } from "swiper/modules";
import { apiGet } from "../../../Utils/apiFetch";
import apiPath from "../../../Utils/apiPath";
import moment from "moment";
import { isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
const Widgets = ({ detail }) => {
  const [show, setShow] = useState(true);
  const navigate = useNavigate();
  const [activeWidget, setActiveWidget] = useState("");
  const [widgetsData, setWidgetsData] = useState([]);
  const getWidgets = async (detail) => {
    const { status, data: response_users } = await apiGet(apiPath.matchList, {
      seriesId: detail?.seriesId,
    });
    if (status === 200) {
      if (response_users?.success) {
        if (response_users?.results?.length > 0) {
          if (isEmpty(activeWidget)) {
            setActiveWidget(detail?._id);
          }
          setWidgetsData(response_users?.results);
        } else {
          setWidgetsData([]);
          setActiveWidget("");
        }
      }
    }
  };
  function isDateToday(date) {
    return moment(date).isSame(moment(), "day");
  }
  useEffect(() => {
    if (!isEmpty(detail)) {
      getWidgets(detail);
    }
  }, [detail]);
  return (
    show &&
    widgetsData?.length > 0 && (
      <div
        data-testid="widget-isShowWidget"
        className="widget fixed bottom-0 z-10 w-full"
        style={{ "--5b1dc2d0": "11.4285714286rem" }}
      >
        <div className="relative bg-secondary space-x-2 pt-6px">
          <div
            className="h-full w-full min-h-44px flex items-center"
            style={{ paddingLeft: "6px" }}
          >
            <Swiper
              modules={[FreeMode]}
              spaceBetween={5}
              slidesPerView={"auto"}
              freeMode={true}
              className="cursor-pointer"
              style={{marginLeft:"inherit"}}
            >
              {widgetsData.map((match) => (
                <SwiperSlide
                  key={match.id}
                  className={`bg-white p-1 rounded-4px duration-500 relative overflow-hidden ${
                    match._id == detail?._id ? "bg-widget-active-bg" : ""
                  }`}
                  style={{ width: "150px" }} // adjust depending on design
                >
                  <div
                    className={`px-1 rounded-t-4px flex items-center ${
                      match._id == detail?._id
                        ? "bg-widget-active-bg text-widget-active-text"
                        : "bg-black-200"
                    }`}
                  >
                    <div className="flex justify-center text-9 leading-4 h-4 space-x-1">
                      <p>
                        {isDateToday(match?.eventDateTime)
                          ? "Today"
                          : moment(match?.eventDateTime).format("DD/MM")}{" "}
                        {moment(match?.eventDateTime).format("HH:MM")}
                      </p>
                    </div>
                  </div>

                  <div
                    onClick={() =>
                      navigate(
                        `/match-detail-velki/${match?.eventId}/${match?.marketId}`
                      )
                    }
                    className="flex w-full h-38px justify-between items-center pl-1 pr-1 rounded-b-4px bg-white"
                  >
                    <div className="w-9/12 h-full pr-2 py-1 flex flex-col justify-around text-12 font-bold">
                      <span className="truncate text-black-900">
                        {match.eventName?.split("v")[0]}
                      </span>
                      <span className="truncate text-black-900">
                        {match.eventName?.split("v")[1]}
                      </span>
                    </div>
                    <div className="w-3/12 h-full text-12 font-bold flex flex-col whitespace-nowrap py-1">
                      <span className="flex-1 flex items-center justify-end text-widget-text">
                        -
                      </span>
                      <span className="flex-1 flex items-center justify-end text-widget-text">
                        -
                      </span>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="text-widget-active-bg flex items-center text-11 leading-20px">
            Crickets in <span className="ml-3px font-bold">24 hours</span>
          </div>
        </div>
        <div
          onClick={() => setShow(false)}
          className="widgetCloseButton absolute top-0 bottom-0 w-40px right-0 flex items-center justify-end z-10"
        >
          <div className="widgetCloseButton w-40px h-full flex items-center justify-end pr-9px">
            <span
              data-testid="widget-closeButton"
              className="icon-close text-white text-12"
            />
          </div>
        </div>
      </div>
    )
  );
};

export default Widgets;
